import CompositeCollapse from '../components/composite-collapse';

export default {
  init() {
    let collapser = new CompositeCollapse('.js-collapse-composite')
    collapser.init()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCheckout.js